import type { RuntimeLogger } from "../runtime/types";

export * from "./StudioScreenRenderer.utils.data";
export * from "./StudioScreenRenderer.utils.path";
export * from "./StudioScreenRenderer.utils.route-params";
export * from "./StudioScreenRenderer.utils.route-screen";
export * from "./StudioScreenRenderer.utils.auth";
export * from "./StudioScreenRenderer.utils.locale";
export * from "./StudioScreenRenderer.utils.locale-route";
export * from "./StudioScreenRenderer.utils.shell";

export const consoleLogger: RuntimeLogger = {
  debug: (message, meta) => console.debug(message, meta),
  info: (message, meta) => console.info(message, meta),
  warn: (message, meta) => console.warn(message, meta),
  error: (message, meta) => console.error(message, meta),
};